export const findRouteConfig = (
  pathname: any,
  routes: any,
  parentPath = ""
): any => {
  // 处理 PUBLIC_URL，去掉前缀
  const base = (process.env.PUBLIC_URL || "").replace(/\/+$/, ""); // 去掉尾斜杠
  if (base && pathname.startsWith(base)) {
    pathname = pathname.slice(base.length) || "/";
  }

  for (const route of routes) {
    const fullPath = `${parentPath}${
      route.path === "/" ? "" : route.path
    }`.replace(/\/+/g, "/");

    // 精确匹配
    if (fullPath === pathname) {
      return route;
    }

    // 如果有 children，递归查找
    if (route.children) {
      const found = findRouteConfig(
        pathname,
        route.children,
        fullPath.endsWith("/") ? fullPath : fullPath + "/"
      );
      if (found) return found;
    }
  }
  return null;
};
